export default "__VITE_ASSET__Dg54Ii2w__"